import React from "react";

import Icon from "../../_static/Icons";
import { close } from "../../_static/Icons/icons";
import messageBoxStylesDefault, { styleMapBySubtype } from "./styles";

import {
  HorizontalMessageBox,
  IconTextWrapper,
  MessageIcon,
  TextWrapper,
  MessageTitle,
  MessageContent,
  CloseBtn,
  ActionLink
} from "./styled-components";

const MessageBoxV2 = (props) => {
  const renderMessage = (color, inlineText) => {
    const { message: PropsMessage, qaLabel = "" } = props;
    const Message = React.isValidElement(PropsMessage) ? (
      <MessageContent
        data-qa-label={`${qaLabel}message-box`}
        color={color}
        inlineText={inlineText}
      >
        {PropsMessage}
      </MessageContent>
    ) : (
      // eslint-disable-next-line react/no-danger
      <MessageContent
        color={color}
        inlineText={inlineText}
        dangerouslySetInnerHTML={{ __html: PropsMessage }}
      />
    );
    return Message;
  };

  const getMsgSubtypeProps = () =>
    (props.subtype && styleMapBySubtype[props.subtype]) || {};

  const { type, hasIcon, title, children, callToAction, className, onClose } =
    props;

  const style = messageBoxStylesDefault[type];
  const messageProps = getMsgSubtypeProps();
  const hasTitle = !!title;
  return (
    <HorizontalMessageBox
      customStyle={style}
      hasIcon={hasIcon}
      hasTitle={hasTitle}
      type={type}
      className={className}
      data-qa-label={`${props.qaLabel || ""}-${type}`}
      {...messageProps}
    >
      <IconTextWrapper>
        {hasIcon && (
          <MessageIcon
            icon={style.icon}
            strokeColorList={style.strokeColorList || []}
            size={16}
            color={style.fill}
            qaLabel={`${props.qaLabel || ""}-icon`}
            viewBoxSize={style.viewBoxSize || 1024}
          />
        )}
        <TextWrapper
          hasIcon={hasIcon}
          data-qa-label={`${props.qaLabel || ""}-text`}
          inlineText={messageProps.inlineText}
        >
          {title && (
            <MessageTitle
              data-qa-label={`${props.qaLabel || ""}-title`}
              color={style.color}
              inlineText={messageProps.inlineText}
            >
              {messageProps.inlineText ? `${title} - ` : title}
            </MessageTitle>
          )}
          {renderMessage(style.color, messageProps.inlineText)}
          {messageProps.hasCallToAction && callToAction && (
            <ActionLink
              to={callToAction.url}
              onClick={callToAction.onClick}
              color={style.color}
            >
              {callToAction.textLink}
            </ActionLink>
          )}
        </TextWrapper>
        {messageProps.hasCloseButton && onClose && (
          <CloseBtn
            onClick={onClose}
            data-qa-label={`${props.qaLabel || ""}-closeBtn`}
          >
            <Icon icon={close} size={16} color={style.color} />
          </CloseBtn>
        )}
      </IconTextWrapper>
      {children}
    </HorizontalMessageBox>
  );
};

MessageBoxV2.defaultProps = {
  type: "default",
  subtype: "floating",
  hasIcon: true,
  children: null,
  className: "",
  qaLabel: "messageBox"
};

export default MessageBoxV2;
